module.exports = __webpack_public_path__ + "img/voir-session.81c279fe.svg";